import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import axios from 'axios';

export default function QuoteRequestForm({ product, products, onClose, onSuccess }) {
    const { t } = useTranslation();
    const config = window.astCatalog || window.astConfig || {};

    // Accept either a single `product` (back-compat) or a `products` array.
    const items = (products && products.length ? products : (product ? [product] : []));

    const [email, setEmail] = useState(localStorage.getItem('ast_lead_email') || '');
    const [name, setName] = useState('');
    const [organization, setOrganization] = useState('');
    const [message, setMessage] = useState('');
    const [status, setStatus] = useState('idle'); // idle, sending, success, error
    const [errorMsg, setErrorMsg] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            setErrorMsg(t('emailGate.invalidEmail'));
            return;
        }
        if (items.length === 0) return;

        setStatus('sending');
        setErrorMsg('');

        try {
            const headers = { 'X-WP-Nonce': config.nonce };

            // Register/verify lead first.
            await axios.post(config.apiUrl + '/leads', { email, name, organization }, { headers });

            if (items.length === 1) {
                await axios.post(config.apiUrl + '/products/' + items[0].id + '/quote-request', {
                    email, name, organization, message, product_id: items[0].id,
                }, { headers });
            } else {
                await axios.post(config.apiUrl + '/products/quote-request', {
                    email, name, organization, message,
                    product_ids: items.map((p) => p.id),
                }, { headers });
            }

            localStorage.setItem('ast_lead_email', email);
            setStatus('success');
            if (onSuccess) onSuccess();
        } catch (err) {
            setStatus('error');
            setErrorMsg(err.response?.data?.message || 'Er is een fout opgetreden.');
        }
    };

    if (status === 'success') {
        return (
            <div className="ast-quote-form__overlay" onClick={onClose}>
                <div className="ast-quote-form" onClick={(e) => e.stopPropagation()}>
                    <div className="ast-quote-form__success">
                        <span className="ast-quote-form__check">&#10003;</span>
                        <h3>Offerte-aanvraag verzonden</h3>
                        <p>
                            We nemen zo spoedig mogelijk contact met u op over{' '}
                            {items.length === 1
                                ? <strong>{items[0].name}</strong>
                                : <strong>{items.length} producten</strong>}.
                        </p>
                        <button className="ast-btn ast-btn--primary" onClick={onClose}>Sluiten</button>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="ast-quote-form__overlay" onClick={onClose}>
            <div className="ast-quote-form" onClick={(e) => e.stopPropagation()}>
                <button className="ast-quote-form__close" onClick={onClose}>&times;</button>

                <h3>{t('catalog.requestQuote')}</h3>

                {items.length === 1 ? (
                    <p className="ast-quote-form__product">
                        {items[0].name}
                        {items[0].sku && <span className="ast-product-card__sku"> {items[0].sku}</span>}
                    </p>
                ) : (
                    <div className="ast-quote-form__product">
                        <strong>{items.length} geselecteerde producten:</strong>
                        <ul style={{ margin: '6px 0 0', paddingLeft: 18 }}>
                            {items.map((p) => (
                                <li key={p.id} style={{ fontSize: 14 }}>
                                    {p.name}{p.sku ? ` (${p.sku})` : ''}
                                </li>
                            ))}
                        </ul>
                    </div>
                )}

                <form onSubmit={handleSubmit}>
                    <div className="ast-form-group">
                        <label>{t('emailGate.email')} *</label>
                        <input
                            type="email"
                            className="ast-input"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                    </div>

                    <div className="ast-form-group">
                        <label>{t('emailGate.name')}</label>
                        <input
                            type="text"
                            className="ast-input"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                        />
                    </div>

                    <div className="ast-form-group">
                        <label>{t('emailGate.organization')}</label>
                        <input
                            type="text"
                            className="ast-input"
                            value={organization}
                            onChange={(e) => setOrganization(e.target.value)}
                        />
                    </div>

                    <div className="ast-form-group">
                        <label>Bericht (optioneel)</label>
                        <textarea
                            className="ast-textarea"
                            rows={3}
                            value={message}
                            onChange={(e) => setMessage(e.target.value)}
                            placeholder="Bijv. gewenste hoeveelheid, specificaties..."
                        />
                    </div>

                    <p style={{ color: '#6b7280', fontSize: 13, margin: '0 0 10px' }}>
                        Genoemde prijzen zijn indicatief.
                    </p>

                    {errorMsg && <p className="ast-error">{errorMsg}</p>}

                    <button
                        type="submit"
                        className="ast-btn ast-btn--primary ast-btn--full"
                        disabled={status === 'sending'}
                    >
                        {status === 'sending' ? '...' : t('catalog.requestQuote')}
                    </button>
                </form>
            </div>
        </div>
    );
}
